export default function(numbersArray) {
    if (numbersArray.length !== 3) {
        return false
    }

    return numbersArray[0].length === 2
        && (numbersArray[1].length === 5 || numbersArray[1].length === 6)
        && numbersArray[2].length === 2
}